const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const revealSelectors = [
  '.shopify-section:not(.header-section):not(.section-group-footer-group) .section',
  '.product-card',
  '.collection-card',
  '.resource-card',
  'footer .group-block',
];

function initScrollReveal(root = document) {
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  const elements = Array.from(root.querySelectorAll(revealSelectors.join(','))).filter((element) => {
    return !element.closest('.cart-drawer, dialog, noscript') && !element.dataset.scrollReveal;
  });

  if (!elements.length) return;

  document.documentElement.classList.add('scroll-reveal-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  elements.forEach((element, index) => {
    const tagName = element.tagName.toLowerCase();
    const revealType = tagName.includes('card') || element.classList.contains('product-card') ? 'scale' : 'up';
    element.dataset.scrollReveal = revealType;
    element.style.setProperty('--scroll-reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);
    observer.observe(element);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initScrollReveal(), { once: true });
} else {
  initScrollReveal();
}

document.addEventListener('shopify:section:load', (event) => initScrollReveal(event.target));
